import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Form, Input, Select, Row, Col, Card, Button, message } from "antd";
import { apiCaller } from "src/util/apiCaller";
import { get, isEmpty } from "lodash";

interface SearchFormProps {
  handleSearch: (values: {
    loai?: string;
    nhom?: string;
    keyword?: string;
  }) => void;
}

const SearchForm: React.FC<SearchFormProps> = ({ handleSearch }) => {
  const [form] = Form.useForm();
  const [listNhomTaiLieu, setListNhomTaiLieu] = useState([]);
  const [listLoaiTaiLieu, setListLoaiTaiLieu] = useState([]);
  const [isLoadingNhomTuLieu, setIsLoadingNhomTuLieu] = useState(false);
  const [isLoadingLoaiTuLieu, setIsLoadingLoaiTuLieu] = useState(false);
  const [isGroupVisible, setGroupVisible] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setGroupVisible(window.innerWidth <= 998);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const resetFields = () => {
    form.resetFields();
  };

  const { id } = useParams<{ id: string }>();
  const idNhomTuLieu = id;

  useEffect(() => {
    resetFields();
    getNhomTaiLieu(idNhomTuLieu || "");
    handleSearch({
      nhom: "",
      loai: "",
      keyword: "",
    });
  }, [idNhomTuLieu]);

  const getNhomTaiLieu = async (idNhomTuLieu: string) => {
    if (idNhomTuLieu) {
      setIsLoadingLoaiTuLieu(true);
      try {
        const url = `apipublic/loaitulieus?idnhomtulieu=${idNhomTuLieu}`;
        const response = await apiCaller({ url, method: "GET" });

        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          setListLoaiTaiLieu(get(response.data, "content", []));
        } else {
          message.error("Không thể tải loại tài liệu");
        }
      } catch (error) {
        message.error("Có lỗi xảy ra khi tải loại tài liệu");
      } finally {
        setIsLoadingLoaiTuLieu(false);
      }
    } else {
      setIsLoadingNhomTuLieu(true);
      try {
        const response = await apiCaller({
          url: "apipublic/nhomtulieus",
          method: "GET",
        });

        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          setListNhomTaiLieu(get(response.data, "content", []));
        } else {
          message.error("Không thể tải nhóm tài liệu");
        }
      } catch (error) {
        message.error("Có lỗi xảy ra khi tải nhóm tài liệu");
      } finally {
        setIsLoadingNhomTuLieu(false);
      }
    }
  };

  const onFinish = (values: any) => {
    handleSearch({
      nhom: values.nhom,
      loai: values.loai,
      keyword: values.keyword,
    });
  };

  const onChangeNhomTuLieu = (value: string) => {
    form.setFieldsValue({ loai: undefined });
    getNhomTaiLieu(value || "");
  };

  const renderForm = () => {
    switch (true) {
      case isGroupVisible:
        return (
          <Form
            layout="vertical"
            form={form}
            name="form1"
            onFinish={onFinish}
            className="form-container wrapper-content-inner"
          >
            <Row gutter={24}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="nhom">
                  <Select
                    allowClear
                    loading={isLoadingNhomTuLieu}
                    onChange={onChangeNhomTuLieu}
                    placeholder="Chọn nhóm tư liệu"
                    style={{ width: "100%" }}
                    options={listNhomTaiLieu}
                    fieldNames={{ label: "tenNhomTuLieu", value: "id" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="loai">
                  <Select
                    allowClear
                    loading={isLoadingLoaiTuLieu}
                    placeholder="Chọn loại tư liệu"
                    style={{ width: "100%" }}
                    options={listLoaiTaiLieu}
                    fieldNames={{ label: "tenLoaiTuLieu", value: "id" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="keyword">
                  <Input placeholder="Nhập từ khóa" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col
                xs={24}
                md={4}
                lg={6}
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "3px",
                }}
              >
                <Button type="primary" style={{ width: "100%" }} htmlType="submit">
                  Tìm kiếm
                </Button>
                <Button
                  style={{ marginLeft: 8, width: "100%" }}
                  onClick={() => form.resetFields()}
                >
                  Đặt lại
                </Button>
              </Col>
            </Row>
          </Form>
        );

      case !isGroupVisible && !isEmpty(listLoaiTaiLieu):
        return (
          <Form
            layout="vertical"
            form={form}
            name="form2"
            style={{ marginBottom: "-20px" }}
            onFinish={onFinish}
            className="form-container wrapper-content-inner"
          >
            <Row gutter={24}>
              <Col xs={24} md={8}>
                <Form.Item name="loai">
                  <Select
                    allowClear
                    loading={isLoadingLoaiTuLieu}
                    placeholder="Chọn loại tư liệu"
                    style={{ width: "100%" }}
                    options={listLoaiTaiLieu}
                    fieldNames={{ label: "tenLoaiTuLieu", value: "id" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="keyword">
                  <Input placeholder="Nhập từ khóa" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={8} style={{ display: "flex" }}>
                <Button type="primary" style={{ width: "100%" }} htmlType="submit">
                  Tìm kiếm
                </Button>
                <Button
                  style={{ marginLeft: 8, width: "100%" }}
                  onClick={() => form.resetFields()}
                >
                  Đặt lại
                </Button>
              </Col>
            </Row>
          </Form>
        );

      case !isGroupVisible:
        return (
          <Form
            layout="vertical"
            form={form}
            name="form3"
            style={{ marginBottom: "-20px" }}
            onFinish={onFinish}
            className="form-container wrapper-content-inner"
          >
            <Row gutter={24}>
              <Col xs={24} md={16}>
                <Form.Item name="keyword">
                  <Input placeholder="Nhập từ khóa" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col xs={24} md={8} style={{ display: "flex" }}>
                <Button type="primary" style={{ width: "100%" }} htmlType="submit">
                  Tìm kiếm
                </Button>
                <Button
                  style={{ marginLeft: 8, width: "100%" }}
                  onClick={() => form.resetFields()}
                >
                  Đặt lại
                </Button>
              </Col>
            </Row>
          </Form>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      {renderForm()}
    </div>
  );
};

export default SearchForm;
